<template>
	<div class="titleBar">
                <div class="left">
                    {{ titleName }}
                </div>
                <div class="getMore" @click="goNews">
                   查看更多
                </div>
	</div>
</template>

<script>
	export default {
		props: {
		    titleName: {
		        type: String,
		        default: '新闻中心'
		    },
		    titleNameEnglish: {
		        type: String,
		        default: 'news Center'
		    }
		},
		
		computed: {
		  
		},
		methods: {
			goNews() {
                let that=this
				that.$emit('goDetail');
			}
		}
	}
</script>

<style lang="scss" scoped>
.titleBar{
        display: flex;
        justify-content: space-between;
        align-items: center;
        // margin-top: 30px;
        // margin-bottom: 24px;
        width: 100%;
        height: 40px;
        .left{
            height: 40px;
            width: 140px;
            background-image: url('../assets/zhuozi/zhuopzi_titlebg.png');
            line-height: 40px;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            font-weight: normal;
            letter-spacing: 0.1em;
            color: #FFFFFF;
            box-sizing: border-box;
            text-align: center;
            padding-left: 10px;

        }
      
        
        .getMore{
            width: 72px;
            height: 24px;
            background-image: url(../assets/zhuozi/getMoreBg.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            font-weight: normal;
            letter-spacing: 0em;
            color: #FFFFFF;
            line-height: 24px;
            text-align: center;
            cursor: pointer;
        }
        .getMore:hover{
            font-weight: 800;
        }
        
			}
	
</style>
